import get from "lodash/get";
import isEqual from "lodash/isEqual";
import { FIELD_ID_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { ManageRolesFormType } from "PFApp/types/activity_form/manage_roles_form_schema";
import { Id } from "PFCore/types";

type RoleFieldChange = {
  roleId: Id;
  fieldName: string;
  nextValue: unknown;
  prevValue: unknown;
};

export const diffRoles = (
  prev: ManageRolesFormType[],
  next: ManageRolesFormType[],
  trackedKeys: Set<string>
): RoleFieldChange[] => {
  const prevById = new Map<Id, ManageRolesFormType>(
    prev.filter((role) => role?.[FIELD_ID_KEY]).map((role) => [role[FIELD_ID_KEY]!, role])
  );

  const changes: RoleFieldChange[] = [];
  next.forEach((role) => {
    const roleId = role?.[FIELD_ID_KEY];

    if (!roleId) {
      return;
    }

    const prevRole = prevById.get(roleId);

    if (!prevRole) {
      return;
    }

    trackedKeys.forEach((fieldName) => {
      const nextValue = get(role, fieldName);
      const prevValue = get(prevRole, fieldName);

      if (!isEqual(nextValue, prevValue)) {
        changes.push({ roleId, fieldName, nextValue, prevValue });
      }
    });
  });

  return changes;
};
